import { handleActions } from 'redux-actions';
import endpoints from '../../../config/endpoints';
import http from '../../shared/http';
import intl from '../../shared/intl';
import { LOCATION_CHANGE } from 'react-router-redux';
import { create as paginationCreate } from '../../shared/pagination';
import { formatEnumFormOptions } from '../../shared/format';
import { SubmissionError, reset } from 'redux-form';

import { REFETCH_ALL_DATA } from '../../root';

import cloneDeep from 'lodash/cloneDeep';
import values from 'lodash/values';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';

const pagination = paginationCreate('tickets', {
	TicketsTable: {
		currentPage: 1,
		perPage: 8
	}
});

// action types
const TICKETS_FETCH_DATA_SUCCESS = 'tickets/fetch-data-success';
const TICKETS_FETCH_DATA_ERROR = 'tickets/fetch-data-error';

const SORT_BY_COLUMN = 'tickets/sort-by-column';
const TOGGLE_PROGRESS_BAR = 'tickets/toggle-progress-bar';

export const UPLOAD_SUCCESS = 'tickets/upload-success';
const UPLOAD_ERROR = 'tickets/upload-error';
const ADD_FILE_TO_UPLOAD = 'tickets/add-file-to-upload';
const REMOVE_FILE_FROM_UPLOAD = 'tickets/remove-file-from-upload';
const SET_LARGE_FILE_ERROR = 'tickets/set-too-large-file-error';

const CREATE_TICKET_SUCCESS = 'tickets/create-ticket-success';
const CREATE_TICKET_ERROR = 'tickets/create-ticket-error';

const OFFER_FETCH_DATA_SUCCESS = 'tickets/offer-fetch-data-success';
const OFFER_FETCH_DATA_ERROR = 'tickets/offer-fetch-data-error';

const SAVE_FORM_STATE = 'tickets/save-form-state';

// initialState state
const initialState = {
	data: null,
	pagination: pagination.initState,
	columns: {
		id: {
			id: 'id',
			direction: 'desc',
			position: 'id',
			title: 'id'
		},
		updated_at: {
			id: 'updated_at',
			direction: 'desc',
			position: 'updated_at',
			title: 'Изменен'
		},
		title: {
			id: 'title',
			direction: 'desc',
			position: 'title',
			title: 'Тема тикета'
		},
		answers_count: {
			id: 'answers_count',
			direction: 'desc',
			position: 'answers_count',
			title: 'Ответы'
		},
		status: {
			id: 'status',
			direction: 'desc',
			position: 'status',
			title: 'Статус'
		}
	},
	columnSorting: {
		key: 'updated_at',
		direction: 'desc',
		position: 'updated_at',
		title: 'Изменен'
	},
	form: {
		fields: {
			title: '',
			text: '',
			priority: null
		},
		priorityOptions: [],
		formName: 'createTicketForm'
	},
	filesToUpload: [],
	createTicketParams: {
		type: null,
		offerId: null
	},
	offerData: null,
	showProgressBar: false,
	error: null,
	uploadError: false
};

// actions
export const actions = {
	fetchData: (props = null) => (dispatch, getState) => {
		const params = props && props.params;
		const formData = props && props.formData;

		const request = http({
			url: endpoints.TICKETS.ALL,
			method: 'get',
			actions: [TICKETS_FETCH_DATA_SUCCESS, TICKETS_FETCH_DATA_ERROR],
			addToResponse: { params, formData }
		});

		request(dispatch).then(action => {
			params && params.offerId && dispatch(actions.offerFetchData(params.offerId));
		});
	},

	offerFetchData: offerId => dispatch => {
		const request = http({
			url: `${endpoints.OFFERS.LIST}/${offerId}`,
			method: 'get',
			actions: [OFFER_FETCH_DATA_SUCCESS, OFFER_FETCH_DATA_ERROR]
		});

		dispatch({ type: TOGGLE_PROGRESS_BAR });

		request(dispatch);
	},

	pagination: () => dispatch => pagination.actions(dispatch),

	sortByColumn: columnKey => ({
		type: SORT_BY_COLUMN,
		payload: columnKey
	}),

	addFileToUpload: file => (dispatch, getState) => {
		if (!file) {
			return;
		}

		dispatch({
			type: ADD_FILE_TO_UPLOAD,
			payload: file
		});

		dispatch({
			type: SET_LARGE_FILE_ERROR,
			payload: isAtachmentsExceedsLimit(getState().tickets.filesToUpload)
		});
	},

	removeFileFromUpload: (fileIndex) => (dispatch, getState) => {
		dispatch({
			type: REMOVE_FILE_FROM_UPLOAD,
			payload: fileIndex
		});

		dispatch({
			type: SET_LARGE_FILE_ERROR,
			payload: isAtachmentsExceedsLimit(getState().tickets.filesToUpload)
		});
	},

	uploadFiles: (postId, filesToUpload, dispatch) => {
		const data = new FormData();

		forEach(filesToUpload, (file, i) => {
			data.append(`file${i}`, file);
		});

		const request = http({
			url: `${endpoints.TICKETS.ALL}/${postId}/attachments`,
			method: 'put',
			actions: [UPLOAD_SUCCESS, UPLOAD_ERROR],
			data
		});

		return request(dispatch);
	},

	createTicket: data => (dispatch, getState) => {
		const state = getState();
		if (isAtachmentsExceedsLimit(state.tickets.filesToUpload)) {
			return;
		}

		data.category = data.category || 'affiliate_question';

		const request = http({
			url: endpoints.TICKETS.ALL,
			method: 'post',
			actions: [CREATE_TICKET_SUCCESS, CREATE_TICKET_ERROR],
			data: {
				...data,
				priority: data.priority.value
			}
		});

		dispatch(actions.toggleProgressBar());

		return request(dispatch).then(action => {

			if (action.type === CREATE_TICKET_SUCCESS) {
				const filesToUpload = state.tickets.filesToUpload;

				if (window.dataLayer && data.category === 'offer_access') {
					window.dataLayer.push({'event': 'FormSubmission', 'eventCategory': 'Offer', 'eventAction': 'GetOffer'});
				}

				dispatch(reset('createTicketForm'));

				if (!isEmpty(filesToUpload)) {
					const postId = action.payload.data.posts[0].id;

					actions.uploadFiles(postId, filesToUpload, dispatch).then(action => {
						if (action.type === UPLOAD_SUCCESS) {
							dispatch(actions.fetchData());
						}
					});

					return;
				}

				dispatch(actions.fetchData());
			}

			if (action.type === CREATE_TICKET_ERROR) {
				dispatch(actions.toggleProgressBar());
				if (action.payload.response.status === 400) {
					dispatch({type: SAVE_FORM_STATE, payload: data});
					const validationsErrors = {};
					const responseErrors = action.payload.response.data;

					forEach(responseErrors, value => {
						const key = value.dataPath.slice(1);
						validationsErrors[key] = value.message;
					});

					throw new SubmissionError(validationsErrors);
				}
			}
		});
	},

	toggleProgressBar: () => ({
		type: TOGGLE_PROGRESS_BAR
	})
};

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[TICKETS_FETCH_DATA_SUCCESS]: (state, action) => {
			const priority = (action.meta.formData && action.meta.formData.priorityOptions[0]) || state.form.fields.priority;
			const createTicketParams = action.payload.mixinData && action.payload.mixinData.params;

			return {
				...state,
				showProgressBar: false,
				data: action.payload.data,
				form: {
					...state.form,
					fields: {
						...state.form.fields,
						priority: priority
					}
				},
				createTicketParams: {
					...state.createTicketParams,
					type: (createTicketParams && createTicketParams.type) || null,
					offerId: (createTicketParams && createTicketParams.offerId) || null
				}
			};
		},
		[CREATE_TICKET_ERROR]: (state, action) => {
			return { ...state };
		},
		[SORT_BY_COLUMN]: (state, action) => {
			const { columnSorting, columns } = state;
			const columnKey = action.payload;

			const columnDirection = columnSorting && columnSorting['key'] === columnKey
				? columnSorting.direction === 'desc' ? 'asc' : 'desc'
				: columns[action.payload].direction;

			return {
				...state,
				columnSorting: {
					...columns[columnKey],
					key: action.payload,
					direction: columnDirection
				}
			};
		},
		[ADD_FILE_TO_UPLOAD]: (state, action) => {
			let filesToUpload = [].concat(state.filesToUpload);
			filesToUpload.push(action.payload);
			return { ...state, filesToUpload: filesToUpload };
		},
		[REMOVE_FILE_FROM_UPLOAD]: (state, action) => {
			let filesToUpload = filter(state.filesToUpload, (f, i) => i != action.payload);
			return { ...state, filesToUpload: filesToUpload };
		},
		[UPLOAD_SUCCESS]: state => ({ ...state, filesToUpload: [], uploadError: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[OFFER_FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			showProgressBar: false,
			offerData: action.payload.data
		}),
		[OFFER_FETCH_DATA_ERROR]: state => ({
			...state,
			error: true
		}),
		[TICKETS_FETCH_DATA_ERROR]: state => ({
			...state,
			error: true
		}),
		[REFETCH_ALL_DATA]: () => initialState,
		[SET_LARGE_FILE_ERROR]: (state, action) => {
			return { ...state, uploadError: action.payload};
		},
		[SAVE_FORM_STATE]: (state, action) => {
			return {
				...state,
				form: {
					...state.form,
					fields: action.payload
				}
			};
		}
	},
	pagination.reducers
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.tickets.data,
	getTableHeaders: state => values(state.tickets.columns),
	getColumnSorting: state => state.tickets.columnSorting,
	getTableData: state =>
		pagination.selectors.getPageData(
			state => state.tickets.data && sortTable(state.tickets.columnSorting, state.tickets.data),
			state => state.tickets.pagination.TicketsTable.perPage,
			state => state.tickets.pagination.TicketsTable.currentPage
		)(state),
	getFormData: state => {
		const priorities = formatEnumFormOptions(state.app.lists['thread-priorities']);
		return {
			initialValues: {
				...state.tickets.form.fields,
				...getFieldsValueByParams(state)
			},
			filesToUpload: state.tickets.filesToUpload,
			priorityOptions: priorities,
			uploadError: state.tickets.uploadError,
			isFromAdmin: state.app.userData.general.is_from_admin
		};
	},
	getTicketParams: state => state.tickets.createTicketParams,
	getProgressBar: state => state.tickets.showProgressBar,
	getIntl: state => intl(state),
	getError: state => state.tickets.error
};

const isAtachmentsExceedsLimit = files => {
	let fileSizeSum = 0;
	forEach(files, (file, i) => {
		fileSizeSum += file.size;
	});
	return fileSizeSum > 5*1024*1024;
};

const sortTable = (sortedColumn, rows) => {
	if (!rows) return null;
	return orderBy(
		rows,
		row => {
			const value = row[sortedColumn.position];
			switch (sortedColumn.position) {
				case 'answers_count':
					return parseInt(row.total_posts) + parseInt(row.new_posts);
				default:
					return value;
			}
		},
		sortedColumn.direction
	);
};

const getFieldsValueByParams = state => {
	const { type, offerId } = state.tickets.createTicketParams;
	const offerData = state.tickets.offerData;
	const intl = selectors.getIntl(state);
	const lang = state.app.userData.general.language;
	return Object.assign(
		{},
		type && offerId && offerData && createTicketFromOffer(type, offerData, intl),
		type && !offerId && createTicketFromProfile(type, intl, lang)
	);
};

const createTicketFromOffer = (type, offer, intl) => {
	const requestChange = {
		'offer-access': {
			title: `${intl('Запрос на доступ к офферу')} "${offer.title}"`,
			category: 'offer_access',
			offer_id: offer.id
		},
		'new-landing': {
			title: `${intl('Добавление транзитки/лендинга к офферу')} "${offer.title}"`,
			category: 'new_landing_transit',
			offer_id: offer.id
		}
	};

	return requestChange[type] || {};
};

const createTicketFromProfile = (type, intl, lang) => {
	const requestChange = {
		'change-phone': {
			title: `${intl('Запрос на изменение номера телефона')}`,
			category: 'affiliate_question',
			text: `${intl('Прошу изменить мне номер телефона на')}`
		},
		'add-personal-domain': {
			title: `${intl('Добавить персональный домен для потоков')}`,
			category: 'affiliate_question',
			text: `${intl('Прошу довабить перскональный домен для потоков')}`
		},
		'change-email': {
			title: `${intl('Запрос на изменение электронной почты')}`,
			category: 'affiliate_question',
			text: `${intl('Прошу изменить мне адрес электронной почты на')}`
		},
		'change-skype': {
			title: `${intl('Запрос на изменение skype')}`,
			category: 'affiliate_question',
			text: `${intl('Прошу изменить мне skype на')}`
		},
		'change-telegram': {
			title: `${intl('Запрос на изменение telegram')}`,
			category: 'affiliate_question',
			text: `${intl('Прошу изменить мне telegram на')}`
		},
		'change-city': {
			title: `${intl('Запрос на изменение города')}`,
			category: 'affiliate_question',
			text: `${intl('Прошу изменить мне город на')}`
		},
		'change-birthday': {
			title: `${intl('Запрос на изменение даты рождения')}`,
			category: 'affiliate_question',
			text: `${intl('Прошу изменить мне дату рождения на')}`
		},
		'improve_translation': {
			title: `${intl('Уточнение перевода для')} "${lang}"`,
			category: 'affiliate_question',
			text: ''
		},
		'new-affiliate': {
			title: `${intl('Добавить вебмастера')}`,
			category: 'affiliate_question',
			text: ''
		},
		'new-master': {
			title: `${intl('Запрос на доступ к мастер аккаунту')}`,
			category: 'affiliate_question',
			text: ''
		}
	};

	return requestChange[type] || {};
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/list/index.js